import { fieldConfig } from "@autoform/zod";
import * as z from "zod";
import { LOG_LEVELS } from "../common/enums";

// ---------------------------------------------------------------------------
// Logging
// ---------------------------------------------------------------------------

const loggingSchema = z.object({
	uploadlevel: z
		.enum(LOG_LEVELS)
		.default("info")
		.check(
			fieldConfig({
				fieldType: "singleselect",
				description: "The log level below which Axiom will log",
			}),
		)
		.describe("Upload Lowest Level"),
});

// ---------------------------------------------------------------------------
// Sound Test
// ---------------------------------------------------------------------------

const soundTestSchema = z.object({
	mp3_player: z.boolean().default(false).describe("Play MP3 Instead of GGWave"),
	recorder: z
		.enum(["script_processor", "media_recorder", "audio_worklet"])
		.default("script_processor")
		.check(fieldConfig({ fieldType: "singleselect" }))
		.describe("Recorder Type"),
});

// ---------------------------------------------------------------------------
// Webapp Global Schema
// ---------------------------------------------------------------------------

export const webappGlobalShape = {
	preloadAI: z.boolean().default(false).describe("Load AI on Front Camera Intro Screen"),
	logging: loggingSchema.prefault({}).describe("Logging"),
	sound_test: soundTestSchema.prefault({}).describe("Sound Test"),
	objectDetectionVersion: z
		.enum(["v1", "v2", "v3"])
		.default("v3")
		.check(fieldConfig({ fieldType: "singleselect" }))
		.describe("Object Detection Version"),
	serviceWorker: z.boolean().default(true).describe("Service Worker"),
};

export const webappGlobalSchema = z.object(webappGlobalShape);

export type WebappGlobalConfig = z.infer<typeof webappGlobalSchema>;
